import { PlanCode } from '../../interfaces';
import PaymentType from '../../interfaces/EPaymentType';

// Register API Error Codes
const ACTIVE_USER_EXISTS = 'ACTIVE_USER_EXISTS';
const INACTIVE_USER_EXISTS = 'INACTIVE_USER_EXISTS';

const PLAN_CODE = 'planCode';
const ANNUAL_PLAN_CODE: PlanCode = 'fffvipa';
const SEASONAL_PLAN_CODE: PlanCode = 'fffvip';

const CREDIT_CARD = 'CREDIT_CARD';
const PAYPAL = 'PAYPAL';
const APPLE_PAY = 'APPLE_PAY';
const VENMO = 'VENMO';

const paymentTypesDictionary = {
  CREDIT_CARD: PaymentType.CREDIT_CARD,
  PAYPAL: PaymentType.PAYPAL,
  APPLE_PAY: PaymentType.APPLE_PAY,
  VENMO: PaymentType.VENMO,
};

// Segment and tracking related constants
const ACQUISITION_COMPLETED = 'Acquisition Completed';
const GTB_PURCHASE = 'GTB Purchase'; // a box subscription purchase on /get-the-box page
const PUBLIC_SUB = 'Public Sub'; // a purchase on Public Shop which only contains 1 or more Public Sub
const INTRO_PURCHASE = 'Intro Product'; // a purchase on Public Shop which only contains 1 or more Intro Product
const PUBLIC_SUB_MEMBER_PURCHASE = 'Public Sub & Intro Product'; // a purchase on Public Shop which only contains 1 or more Public Sub and 1 or more Intro Product
const PUBLIC_SUB_NON_MEMBER_PURCHASE = 'Public Sub & Non-Member Purchase' // a purchase on Public Shop which only contains 1 or more Public Sub and 1 or more SKU at the “Non-Member” purchase price
const NON_MEMBER_PURCHASE = 'Non-Member Purchase Intro'; // a purchase on Public Shop which only contains 1 or more SKU at the “Non-Member” purchase price

const PURCHASE_PRODUCT_TYPE = {
  gtb: GTB_PURCHASE,
  publicSub: PUBLIC_SUB,
  introProduct: INTRO_PURCHASE,
  publicSubMember: PUBLIC_SUB_MEMBER_PURCHASE,
  publicSubNonMember: PUBLIC_SUB_NON_MEMBER_PURCHASE,
  nonMember: NON_MEMBER_PURCHASE,
};

const PURCHASE_EVENT = {
  gtb: {
    event: 'purchase',
    loggerMessage: 'GTB - PURCHASE EVENT',
  },
  intro: {
    event: 'Intro Product Subscribe',
    loggerMessage: 'INTRO PRODUCT - PURCHASE EVENT',
  },
  refill: {
    event: 'Public Subscription Purchase',
    loggerMessage: 'PUBLIC SUBSCRIPTION - PURCHASE EVENT',
  },
};

// Cookie related constants
const COOKIE = {
  key: 'fff_registration_flow',
  value: 'intro-product',
};

// Tracking event names and properties
const FORM_ELEMENT_CLICKED = 'Clicked Element';
const FORM_ENTRY = 'Form Entry';

// Test ids:
const PASSWORD_TOOLTIP_CONTAINER = 'Password ToolTip';

export {
  PLAN_CODE,
  ANNUAL_PLAN_CODE,
  SEASONAL_PLAN_CODE,
  CREDIT_CARD,
  PAYPAL,
  APPLE_PAY,
  VENMO,
  FORM_ELEMENT_CLICKED,
  FORM_ENTRY,
  PASSWORD_TOOLTIP_CONTAINER,
  paymentTypesDictionary,
  PURCHASE_EVENT,
  ACQUISITION_COMPLETED,
  PURCHASE_PRODUCT_TYPE,
  COOKIE,
  ACTIVE_USER_EXISTS,
  INACTIVE_USER_EXISTS,
};
